/**
 * Insider Integration — SDK Initialization & Queue Manager
 * Uses window.InsiderQueue pattern (same as ecom.storefront).
 */

import { insiderConfig } from './insider.config';
import { EInsiderQueueType, type IInsiderQueueBase } from './insider.types';

let initialized = false;

function ensureQueue(): void {
  window.InsiderQueue = window.InsiderQueue || [];
}

/**
 * Initialize the Insider Web SDK.
 * Loads the partner script and creates the queue.
 */
export function initializeInsider(): void {
  if (initialized || !insiderConfig.enabled || !insiderConfig.partnerName) {
    return;
  }

  ensureQueue();

  const script = document.createElement('script');
  script.async = true;
  script.src = `https://${insiderConfig.partnerName}.api.useinsider.com/ins.js?id=${insiderConfig.partnerName}`;
  document.head.appendChild(script);

  initialized = true;
}

/**
 * Push an item to the InsiderQueue.
 */
export function queuePush(item: IInsiderQueueBase): void {
  if (!insiderConfig.enabled) return;
  ensureQueue();
  window.InsiderQueue.push(item);
}

/**
 * Commit the queue (push init signal so SDK processes pending items).
 */
export function queueCommit(): void {
  if (!insiderConfig.enabled) return;
  ensureQueue();
  window.InsiderQueue.push({ type: EInsiderQueueType.init });
}

/**
 * Check if Insider integration is enabled.
 */
export function isInsiderEnabled(): boolean {
  return insiderConfig.enabled;
}
